module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_6005.410e642e.png";